import { reactive, toRefs, ref, computed } from "vue";
import { doLikeAction, getCharLikeNum } from "@api/like";
import useCharInfo from "@hooks/useCharInfo";
import { getText } from "@config/siteConfig";
const LIKE_TYPE_MAP = {
  article: "ARTICLE",
};

export default function useLike(likeTypeP) {
  const id = ref("");
  const likeType = ref("");
  likeType.value = LIKE_TYPE_MAP[likeTypeP];
  const { gameId, loginAccount, roleId } = useCharInfo();
  const showLikeBtn = computed(() => gameId.value && loginAccount.value);

  const likeState = reactive({
    linkTotalNum: 0,
    isLike: false,
  });

  // 点赞
  const like = async () => {
    const res: any = await doLikeAction({
      gameId: gameId.value,
      id: id.value,
      loginAccount: loginAccount.value,
      action: "LIKE",
      likeType: likeType.value,
      roleId: roleId.value,
    });
    if (res?.result == 1 && res?.data) {
      likeState.linkTotalNum = res.data.TOTAL || 0;
      likeState.isLike = true;
    } else {
      alert(getText("likeFail"));
    }
  };

  // 取消点赞
  const cancelLike = async () => {
    const res: any = await doLikeAction({
      gameId: gameId.value,
      id: id.value,
      loginAccount: loginAccount.value,
      action: "CANCEL_LIKE",
      likeType: likeType.value,
      roleId: roleId.value,
    });
    if (res?.result == 1 && res?.data) {
      likeState.linkTotalNum = res.data.TOTAL || 0;
      likeState.isLike = false;
    } else {
      alert(getText("likeFail"));
    }
  };

  // 获取点赞数据
  const updateLikeData = async (initId: string) => {
    id.value = initId;
    const res: any = await getCharLikeNum({
      gameId: gameId.value,
      id: id.value,
      loginAccount: loginAccount.value,
      likeType: likeType.value,
    });
    if (res?.result == 1 && res?.data) {
      likeState.linkTotalNum = res.data.TOTAL || 0;
      likeState.isLike = Boolean(+res.data.IS_LIKE) || false;
    }
  };

  return {
    showLikeBtn,
    like,
    cancelLike,
    updateLikeData,
    ...toRefs(likeState),
  };
}
